import axios from "axios";
import _ from "lodash";

const preinscriptionAppelsServeur = {
  url: process.env.VUE_APP_WS_URL
};

export default preinscriptionAppelsServeur;

// authentication.ws
preinscriptionAppelsServeur.getAuthenticationToken = async function(id) {
  const responseAuthentication = await axios.post(
    preinscriptionAppelsServeur.url + "authentication.ws",
    {
      userName: encodeURIComponent(id)
    }
  );
  return responseAuthentication.data;
};

// getCaptcha.ws
preinscriptionAppelsServeur.getCaptcha = async function(token) {
  const captchaInfo = await axios.get(
    preinscriptionAppelsServeur.url + "preinscription/getCaptcha.ws",
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return captchaInfo;
};

// getInstructionsCaptcha.ws
preinscriptionAppelsServeur.getInstructionsCaptcha = async function(token) {
  const instructionsCaptcha = await axios.get(
    preinscriptionAppelsServeur.url +
      "preinscription/getInstructionsCaptcha.ws",
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return instructionsCaptcha;
};

// getPayment.ws
preinscriptionAppelsServeur.getPayment = async function(token) {
  const responseGetPayment = await axios.get(
    preinscriptionAppelsServeur.url + "preinscription/getPayment.ws",
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return responseGetPayment;
};

// postEtape.ws
preinscriptionAppelsServeur.postEtape = async function(
  token,
  numeroEtape,
  numeroEtapeSuivante,
  validation,
  postPreinscription
) {
  const responsePostEtape = await axios.post(
    preinscriptionAppelsServeur.url +
      "preinscription/postEtape.ws?numeroEtape=" +
      numeroEtape +
      "&numeroEtapeSuivante=" +
      numeroEtapeSuivante +
      "&validation=" +
      validation,
    postPreinscription,
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return responsePostEtape.data;
};

// postValidationPaiement.ws
preinscriptionAppelsServeur.postValidationPaiement = async function(
  token,
  checkoutIntentId
) {
  await axios.post(
    preinscriptionAppelsServeur.url +
      "preinscription/postValidationPaiement.ws?checkoutIntentId=" +
      checkoutIntentId,
    {},
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
};

// getPreinscription.ws
preinscriptionAppelsServeur.getPreinscription = async function(
  token,
  dateNaissance,
  codesCaptcha
) {
  const responseGetPreinscription = await axios.get(
    preinscriptionAppelsServeur.url +
      "preinscription/getPreinscription.ws?dateNaissance=" +
      dateNaissance +
      "&codesCaptcha=" +
      codesCaptcha,
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return responseGetPreinscription;
};

preinscriptionAppelsServeur.getByName = async function(token, name) {
  const responseGetByName = await axios.get(
    preinscriptionAppelsServeur.url + "referential/getByName.ws?name=" + name,
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return responseGetByName;
};

preinscriptionAppelsServeur.getVille = async function(token, libelle) {
  if (libelle.length < 2) {
    return null;
  }
  const responseGetVille = await axios.get(
    preinscriptionAppelsServeur.url +
      "preinscription/getVille.ws?libelle=" +
      libelle,
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return responseGetVille;
};

preinscriptionAppelsServeur.getOffresPratique = async function(token) {
  const offresPratique = await axios.get(
    preinscriptionAppelsServeur.url + "preinscription/getOffrePratique.ws?",
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return offresPratique;
};

// getJustificatifs.ws
preinscriptionAppelsServeur.getJustificatifs = async function(token, mutation) {
  const justificatifs = await axios.get(
    preinscriptionAppelsServeur.url +
      "preinscription/getJustificatifs.ws?mutation=" +
      mutation,
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return justificatifs;
};

// putDocument.ws
preinscriptionAppelsServeur.putDocument = async function(token, document) {
  const responsePutDocument = await axios.put(
    preinscriptionAppelsServeur.url + "preinscription/putDocument.ws?",
    document,
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return responsePutDocument.data;
};

// getDocumentsClub.ws
preinscriptionAppelsServeur.getDocumentsClub = async function(token) {
  const documentsClub = await axios.get(
    preinscriptionAppelsServeur.url + "preinscription/getDocumentsClub.ws",
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return documentsClub;
};

// getTableauPrixLicencie.ws
preinscriptionAppelsServeur.getTableauPrixLicencie = async function(token) {
  const tableauPrixLicencie = await axios.get(
    preinscriptionAppelsServeur.url +
      "preinscription/getTableauPrixLicencie.ws",
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );
  return tableauPrixLicencie;
};

// postMessage.ws
preinscriptionAppelsServeur.postMessage = async function(token, club, contenu) {
  const postMessage = await axios.post(
    preinscriptionAppelsServeur.url + "preinscription/postMessage.ws?",
    {
      club: club,
      contenu: contenu
    },
    {
      crossdomain: true,
      headers: {
        Authorization: "Basic " + token
      }
    }
  );

  return postMessage;
};

preinscriptionAppelsServeur.getAgeLicencie = function(
  dateNaissance,
  dateFinSaison
) {
  if (
    dateNaissance === null ||
    dateNaissance === "" ||
    dateFinSaison === null ||
    dateFinSaison === ""
  ) {
    return 0;
  }

  var dates = dateNaissance.split("-");
  var anneeDateNaissance = dates[0];
  var moisDateNaissance = dates[1];
  var jourDateNaissance = dates[2];

  var anneeFinSaison = dateFinSaison.substring(0, 4);

  var res = anneeFinSaison - anneeDateNaissance;
  if (
    moisDateNaissance > 1 ||
    (moisDateNaissance == 1 && jourDateNaissance >= 1)
  ) {
    res--;
  }
  return res;
};

// Retourne l'âge du licencié à la date actuelle
preinscriptionAppelsServeur.getAgeLicencieParDateCourante = function(
  dateNaissance
) {
  if (dateNaissance === null || dateNaissance === "") {
    return 0;
  }

  var dates = dateNaissance.split("-");
  var anneeDateNaissance = dates[0];
  var moisDateNaissance = dates[1];
  var jourDateNaissance = dates[2];

  var now = new Date();
  var anneeCourante = now.getFullYear();
  var moisCourant = now.getMonth() + 1;
  var jourCourant = now.getDate();

  var res = anneeCourante - anneeDateNaissance;
  if (
    moisDateNaissance > moisCourant ||
    (moisDateNaissance == moisCourant && jourDateNaissance > jourCourant)
  ) {
    res--;
  }
  return res;
};

// format date dd/MM/yyyy hh:mm:ss
preinscriptionAppelsServeur.formatDateWithTime = function(date) {
  if (date === null || date === "") {
    return "";
  }

  var formatDate =
    _.padStart(date.getDate(), 2, "0") +
    "/" +
    _.padStart(date.getMonth() + 1, 2, "0") +
    "/" +
    date.getFullYear() +
    " " +
    _.padStart(date.getHours(), 2, "0") +
    ":" +
    _.padStart(date.getMinutes(), 2, "0") +
    ":" +
    _.padStart(date.getSeconds(), 2, "0");

  return formatDate;
};

// format date yyyy-MM-dd
preinscriptionAppelsServeur.formatDateWithoutTime = function(date) {
  if (date === null || date === "") {
    return "";
  }

  var formatDate =
    date.getFullYear() +
    "-" +
    _.padStart(date.getMonth() + 1, 2, "0") +
    "-" +
    _.padStart(date.getDate(), 2, "0");

  return formatDate;
};

// format date dd/MM/yyyy
preinscriptionAppelsServeur.formatDateOnBoarding = function(date) {
  if (date === null || date === "") {
    return "";
  }

  var formatDate =
    _.padStart(date.getDate(), 2, "0") +
    "/" +
    _.padStart(date.getMonth() + 1, 2, "0") +
    "/" +
    date.getFullYear();

  return formatDate;
};

// format date au format français dd/MM/yyyy (la date d'entrée est au format yyyy-MM-dd)
preinscriptionAppelsServeur.formatDateFrancais = function(date) {
  if (date === null || date === "") {
    return "";
  }

  var dateArray = date.split("-");
  return dateArray[2] + "/" + dateArray[1] + "/" + dateArray[0];
};

// format montant au format français ###,##
preinscriptionAppelsServeur.formatMontant = function(montant) {
  if (montant === null || montant === "") {
    return "";
  }

  if (montant.startsWith("00")) {
    let formatMontant = montant.substring(1, montant.length);
    return formatMontant.replace(".", ",");
  }

  return montant.replace(".", ",");
};

preinscriptionAppelsServeur.getLibelleSaisonPrecedente = function(
  dateDebut,
  dateFin
) {
  if (
    dateDebut === null ||
    dateDebut === "" ||
    dateFin === null ||
    dateFin === ""
  ) {
    return "";
  }

  var dates = dateDebut.split("-");
  var anneeDebutSaisonPrecedente = dates[0] - 1;
  dates = dateFin.split("-");
  var anneeFinSaisonPrecedente = dates[0] - 1;

  return (
    "saison " + anneeDebutSaisonPrecedente + "-" + anneeFinSaisonPrecedente
  );
};

preinscriptionAppelsServeur.downloadAssurancePdfFile = async function() {
  try {
    axios({
      url: require("@/static/assurance.pdf").default,
      method: "GET",
      responseType: "blob"
    }).then(response => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        "Notice d’information assurance RC_IA_2025 2026.pdf"
      );
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  } catch (error) {
    if (error.response) {
      // console.log(error.response.data);
    }
  }
};

preinscriptionAppelsServeur.downloadQuestionnaireSanteMajeur = async function() {
  try {
    axios({
      url: require("@/static/cerfa_15699-01.pdf").default,
      method: "GET",
      responseType: "blob"
    }).then(response => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "QUESTIONNAIRE SANTE.pdf");
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  } catch (error) {
    if (error.response) {
      // console.log(error.response.data);
    }
  }
};

preinscriptionAppelsServeur.downloadQuestionnaireSanteMineur = async function() {
  try {
    axios({
      url: require("@/static/questionnaire_sante_mineurs.pdf").default,
      method: "GET",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      responseType: "blob"
    }).then(response => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "QUESTIONNAIRE SANTE.pdf");
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  } catch (error) {
    if (error.response) {
      // console.log(error.response.data);
    }
  }
};

preinscriptionAppelsServeur.downloadGarantiePdfFile = async function() {
  try {
    axios({
      url: require("@/static/garanties.pdf").default,
      method: "GET",
      responseType: "blob"
    }).then(response => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "TABLEAU DES GARANTIES.pdf");
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  } catch (error) {
    if (error.response) {
      // console.log(error.response.data);
    }
  }
};

preinscriptionAppelsServeur.traitementErreursServeur = function(
  error,
  isReconnected,
  thatVue,
  thatFunction,
  argsArray
) {
  if (error.response) {
    var traitementErreur = preinscriptionAppelsServeur.traitementErreur(
      error.response,
      isReconnected
    );
    // tentative de reconnection (une seule) => puis rappel du web service => si un nouvel échec survient l'erreur est retournée
    if (traitementErreur.serverError.forceReconnect) {
      preinscriptionAppelsServeur
        .getAuthenticationToken(thatVue.$route.query.id)
        .then(result => {
          thatVue.token_out = result;
          if (thatVue.token_out != null) {
            if (!argsArray) {
              argsArray = [];
            }
            argsArray.push(true);
            // rappel du web service apres reconnection (isReconnected = true)
            thatFunction.apply(thatVue, argsArray);
          } else {
            thatVue.token_out = null;
            thatVue.erreurGlobale =
              preinscriptionAppelsServeur.formatDateWithTime(new Date()) +
              " Cette préinscription n'est pas reconnue ou n'est plus valide";
          }
        })
        .catch(error => {
          if (error.response) {
            thatVue.erreurGlobale =
              preinscriptionAppelsServeur.formatDateWithTime(new Date()) +
              " Cette préinscription n'est pas reconnue ou n'est plus valide";
            if (thatVue.serverError !== undefined) {
              thatVue.serverError = thatVue.erreurGlobale;
            }
          } else {
            thatVue.erreurGlobale =
              preinscriptionAppelsServeur.formatDateWithTime(new Date()) +
              " Le serveur est momentanément indisponible. Merci de réessayer un peu plus tard";
          }
        });
    } else {
      thatVue.erreurGlobale = traitementErreur.serverError.errorText;
    }
  } else {
    thatVue.erreurGlobale =
      preinscriptionAppelsServeur.formatDateWithTime(new Date()) +
      " Le serveur est momentanément indisponible. Merci de réessayer un peu plus tard";
  }
};

preinscriptionAppelsServeur.traitementErreur = function(
  errorResponse,
  isReconnected
) {
  if (errorResponse.status === 401 && !isReconnected) {
    // tentative de reconnection (une seule), pas de message
    return { serverError: { errorText: null, forceReconnect: true } };
  }
  var errorMessage = "";
  if (errorResponse.status === 401) {
    // si un nouvel échec survient l'erreur est retournée
    errorMessage = preinscriptionAppelsServeur.formatErrorMessage(
      errorResponse.data.message
        ? errorResponse.data.message
        : errorResponse.data,
      errorResponse.status
    );
  } else if (errorResponse.status === 404) {
    errorMessage = preinscriptionAppelsServeur.formatErrorMessage(
      "Le serveur est momentanément indisponible. Merci de réessayer un peu plus tard",
      errorResponse.status
    );
  } else if (errorResponse.status === 403) {
    errorMessage = preinscriptionAppelsServeur.formatErrorMessage(
      errorResponse.data != null
        ? errorResponse.data
        : "L'action n'est pas autorisée",
      errorResponse.status
    );
  } else if (errorResponse.status === 500) {
    if (errorResponse.data) {
      errorMessage = preinscriptionAppelsServeur.formatErrorMessage(
        errorResponse.data.message
          ? errorResponse.data.message
          : errorResponse.data,
        errorResponse.status
      );
    } else {
      errorMessage = preinscriptionAppelsServeur.formatErrorMessage(
        "Erreur interne au serveur",
        errorResponse.status
      );
    }
  } else if (errorResponse.status === 400) {
    if (errorResponse.data.id && errorResponse.data.erreurs.length != 0) {
      errorResponse.data.erreurs.forEach(err => {
        if (err.message != null && err.message != "") {
          errorMessage += preinscriptionAppelsServeur.formatErrorMessage(
            err.message,
            null
          );
        }
        if (err.mandatory === true) {
          errorMessage += preinscriptionAppelsServeur.formatErrorMessage(
            "Le champ " + err.field + " est requis",
            null
          );
        }
        if (err.badFormat === true) {
          errorMessage += preinscriptionAppelsServeur.formatErrorMessage(
            "Le champ " + err.field + " n'a pas le bon format",
            null
          );
        }
        errorMessage += "\n";
      });
    } else {
      errorMessage = preinscriptionAppelsServeur.formatErrorMessage(
        errorResponse.data != null ? errorResponse.data : "Erreur serveur",
        errorResponse.data != null ? null : errorResponse.status
      );
    }
  } else {
    errorMessage = preinscriptionAppelsServeur.formatErrorMessage(
      "Erreur serveur",
      errorResponse.status
    );
  }

  return {
    serverError: {
      errorText: errorMessage,
      forceReconnect: false
    }
  };
};

preinscriptionAppelsServeur.formatErrorMessage = function(
  errorMessage,
  statusCode
) {
  return (
    preinscriptionAppelsServeur.formatDateWithTime(new Date()) +
    " " +
    errorMessage +
    (statusCode != null ? " (" + statusCode + ")" : "")
  );
};
